<template>
    <v-tooltip location="top">
        <template v-slot:activator="{props}">
            <v-chip
                :color="specialOfferChipColor"
                size="small"
                class="text-caption cursor-pointer"
                v-bind="details && !isMobile ? props : null"
            >
                {{ $t('special_offer') }}</v-chip
            >
        </template>
        <span>{{ details }}</span>
    </v-tooltip>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class SpecialOfferLabel extends Vue {
        @Prop() details

        get specialOfferChipColor() {
            return 'success'
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default SpecialOfferLabel
</script>
